// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"66946ddf","72":"d5d3ecc4","325":"26040b05","455":"9bee4a85","496":"2b224f1b","581":"fed1e0c9"}[chunkId] + ".chunk.js";
};